import timestampValue from '../../../Timestamp/lib/value'

export default ({ formikProps }) => {
  if (timestampValue({ formikProps })) {
    return 'condition.termOne.condition.termTwo'
  }

  return 'condition.termTwo'
}
